var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-event-odd",class:[
    {
      'bto-sb-odd-lock':
        _vm.formatedOdd === '--' || _vm.outcome.active === false || _vm.match.isBetStop || _vm.isSuspended,
      'bto-sb-event-odd-active': _vm.isOddSelected,
      'bto-sb-odd-up': _vm.outcome.upDownClass === 1,
      'bto-sb-odd-dw': _vm.outcome.upDownClass === -1,
    },
    _vm.comboClass,
    _vm.quickBetClasses,
  ],on:{"click":_vm.processOdd}},[(_vm.getQuickBetNotification && _vm.getQuickBetNotification.betslip.status === 4)?_c('span',{staticClass:"bto-sb-spinner-v1"}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.outcome.enrichedOutcomeName || _vm.getOutcomeName(_vm.outcome)))]),_c('span',[_vm._v(_vm._s(_vm.formatedOdd))])])
}
var staticRenderFns = []

export { render, staticRenderFns }